import { Alert, List, ListItem, Stack, Text } from '@chakra-ui/react'
import type { FieldErrors, FieldValues } from 'BrokerTsLib/src/rhf'

type ErrorSummaryProps<T extends FieldValues> = {
  errors: FieldErrors<T>
}

const ErrorSummary = <T extends object>({ errors }: ErrorSummaryProps<T>) => {
  if (Object.keys(errors).length === 0) {
    return null
  }

  return (
    <Alert colorScheme="red" mb={8}>
      <Stack display={'flex'} ml={'auto'}>
        <List sx={{ display: 'flex', flexDir: 'column', alignItems: 'start' }} gap={1}>
          {
            getObjectKeyValues(errors).map((item) => (
              <ListItem key={item.fieldName}>
                <Text variant={'danger'}>
                  {item.value?.message}
                </Text>
              </ListItem>
            ))
          }
        </List>
      </Stack>
    </Alert>
  )
}

export type ObjectKeyValue = { fieldName: string, value: any }
export const getObjectKeyValues = (object: any, path: string[] = []): ObjectKeyValue[] => {
  let arr: ObjectKeyValue[] = []

  for (const propName in object) {
    if (object[propName] !== null
            && typeof object[propName] === 'object'
            && !object[propName].message
            // && !object[propName].type // nefungovalo pak napr u osoba.type apod.
            && !object[propName].ref
    ) // nejedna uz o validacni hlasku
    {
      arr = [...arr, ...getObjectKeyValues(object[propName], [...path, propName])]
    } else {
      arr.push({
        fieldName: [...path, propName].join('.'),
        value: object[propName]
      })
    }
  }


  return arr
}

export default ErrorSummary